<template>
  <div class="myyja-floating" data-jscroll="true">
    <div class="myyja-button-grid">
      <p>
        {{ is_industry ? t("buttonTitleFactory") : t("buttonTitle") }}
      </p>
      <div class="phone-icon">
        <i class="fal fa-phone"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { useI18n } from "vue-i18n";
import { mapState } from "vuex";

export default {
  name: "FloatingButton",
  setup() {
    const { locale, t } = useI18n();

    return { locale, t };
  },
  computed: {
    ...mapState(["is_industry"]),
  },
};
</script>
<style lang="scss" scoped>
.myyja-floating {
  position: absolute;
  right: 0.5rem;
  z-index: 9;
  max-width: 300px;
  background-color: var(--bs-yellow);
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  border-radius: 2rem;
  transition: all 0.3s;
  cursor: pointer;

  &.scrollDown:not(.scrollTop) {
    /*top: 1rem;
    transition: top 0.3s;*/
    padding-left: 0.5rem;

    .myyja-button-grid {
      p {
        opacity: 0;
        width: 0;
        margin: 0;
        transition: opacity, width 0.2s;
      }
    }
  }
}

.myyja-button-grid {
  display: flex;
  align-items: center;

  p {
    font-weight: 500;
    margin: 0 1rem 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    width: 125px;
    white-space: nowrap;
    overflow: hidden;
    opacity: 1;
    transition: opacity, width 0.2s;
  }

  .phone-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: 50%;

    i {
      font-size: 20px;
    }
  }

  @media screen and (min-width: 768px) {
    p {
      font-size: 20px;
      width: 160px;
    }
    i {
      font-size: 22px;
    }
  }
}
</style>
